import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ResponsiveImage } from '../ResponsiveImage';
import { LinkButton, Heading } from '../../atoms';
import { useReporter } from '../../reporter';
import {
  boxShippingSoonBackDashboard,
  boxShippingSoonInitiated,
} from './events';
import {
  StyledBoxShippingSoon,
  WarningText,
  DateText,
  DateContainer,
  InfoText,
  ImageContainer,
} from './styles.js';

export const BoxShippingSoon = ({
  headline,
  warningText,
  infoText,
  image,
  buttonLabel,
  buttonUrl,
  dateText,
}) => {
  const reporter = useReporter();
  useEffect(() => {
    reporter.tag(boxShippingSoonInitiated());
  }, [reporter]);
  const onBoxShippingSoonBackDashboardClick = () => {
    reporter.tag(boxShippingSoonBackDashboard());
  };

  return (
    <StyledBoxShippingSoon>
      <ImageContainer>
        <ResponsiveImage {...image} />
      </ImageContainer>
      <Heading
        headingLevel="h2"
        typography={{
          desktop: 'heading1',
          mobile: 'heading2',
        }}
        position="center"
        headingText={headline}
      />
      <DateContainer>
        <InfoText>{infoText}</InfoText>
        <DateText>{dateText}</DateText>
      </DateContainer>
      <WarningText>{warningText}</WarningText>
      <LinkButton
        href={buttonUrl}
        onClick={onBoxShippingSoonBackDashboardClick}
      >
        {buttonLabel}
      </LinkButton>
    </StyledBoxShippingSoon>
  );
};

BoxShippingSoon.displayName = 'BoxShippingSoon';

BoxShippingSoon.propTypes = {
  headline: PropTypes.string.isRequired,
  warningText: PropTypes.string.isRequired,
  infoText: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  buttonUrl: PropTypes.string.isRequired,
  dateText: PropTypes.string.isRequired,
};
